import BlockchainOrders from './BlockchainOrders';

export default BlockchainOrders;



// WEBPACK FOOTER //
// ./src/views/blockchainOrders/index.js